(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["muriclyn-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('muriclyn-purchase-options')) {
    customElements.define('muriclyn-purchase-options', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.modes = [...this.querySelectorAll('input[name^="purchase-mode-"]')];
        this.variants = [...this.querySelectorAll('input[name="id"]')];
        this.plan = this.querySelector('[name="selling_plan"]');
        this.once = this.variants.find(input => input.checked)?.value;
        const section = document.getElementById('shopify-section-' + this.dataset.section);
        section?.querySelectorAll('sticky-atc select').forEach(select => {
          select.addEventListener('change', event => {
            const id = select.selectedOptions[0]?.dataset.variantId;
            const variant = this.variants.find(input => input.value === id && !input.disabled);
            if (!variant) return;
            event.stopImmediatePropagation();
            this.modes[0].checked = true;
            this.once = variant.value;
            this.sync();
          }, true);
        });
        this.modes.forEach(input => { if (input.value && input.dataset.available === 'true') input.disabled = false; });
        this.addEventListener('change', event => {
          if (event.target.name === 'id') this.once = event.target.value;
          this.sync();
        });
        this.sync();
      }
      sync() {
        const mode = this.modes.find(input => input.checked);
        if (!mode) return;
        const recurring = Boolean(mode.value);
        const variant = this.variants.find(input => input.value === (recurring ? mode.dataset.variant : this.once));
        if (!variant) return;
        variant.checked = true;
        this.plan.value = mode.value;
        this.plan.disabled = !recurring;
        this.querySelector('.mrc-purchase__variants').hidden = recurring;
        this.querySelector('.mrc-purchase__details').hidden = !recurring;
        const choice = recurring ? mode : variant;
        const section = document.getElementById('shopify-section-' + this.dataset.section);
        section?.querySelectorAll('.main-price').forEach(node => { node.textContent = choice.dataset.price; });
        section?.querySelectorAll('.main-comapre-price').forEach(node => { node.textContent = choice.dataset.compare; });
        section?.querySelectorAll('[id^="main-price-"]').forEach(node => {
          node.classList.toggle('price--on-sale', Boolean(choice.dataset.compare));
          node.querySelectorAll('.price__badge-sale').forEach(badge => { badge.hidden = true; });
        });
        section?.querySelectorAll('sticky-atc .price-item--sale').forEach(node => { node.textContent = choice.dataset.price; });
        section?.querySelectorAll('sticky-atc s.price-item--regular').forEach(node => { node.textContent = choice.dataset.compare; });
        section?.querySelectorAll('sticky-atc select').forEach(select => {
          const option = [...select.options].find(item => item.dataset.variantId === variant.value);
          if (option) select.value = option.value;
          select.disabled = recurring;
        });
        section?.querySelectorAll('.sticky-atc__label__text').forEach(node => { node.textContent = recurring ? this.dataset.subscribe : this.dataset.add; });
        const button = document.getElementById(this.dataset.form)?.querySelector('[name="add"]');
        if (button) {
          button.disabled = choice.dataset.available !== 'true';
          const label = button.querySelector('.main-atc__label__text');
          if (label) label.textContent = button.disabled ? this.dataset.unavailable : (recurring ? this.dataset.subscribe : this.dataset.add);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
